import axios from 'axios';
import { AuthContext } from '../../contexts/AuthContext';
import '../../assets/css/components/program.css'
import { useEffect, useState, useContext } from 'react';
import { CustomTable } from '../../components/utility/Utility';
import {useNavigate, useSearchParams} from 'react-router-dom';
import { InitiateTutorial, ActionDescription } from '../../components/Onboarding';
export default function Giveaways() {
  const {handleSignOut, getJwtToken} = useContext(AuthContext);
  const [giveaways, setGiveaways] = useState(false);
  const [pageInfo, setPageInfo] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tutorial, setTutorial] = useState(0);

  const navigate = useNavigate();

  useEffect(() => {
    const getGiveaways = async () => {
      const tutorial = searchParams.get('tutorial');
      if (tutorial === 'true') setTutorial(1);
      try {
        const token = await getJwtToken();
        const res = await axios.get('https://api.amplifyloyalty.com/app/stores/giveaways',
        {
          headers: { Authorization: `Bearer ${token}` },
          params: {ph: ""}
        });
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else {
          let info = {...res.data}
          delete info.data;
          setPageInfo(info);
          setGiveaways(res.data.docs);
        }
      } catch (err) {
        console.log(err);
      }
    }
    getGiveaways();
  }, [])

  const createGiveaway = async () => {
    if (tutorial > 0) {
      navigate('/app/giveaways/tutorial');
    } else {
      const button = document.querySelector('.giveaways-header__create-new');
      button.disabled = true;
      let today = new Date();
      let arbitraryEnd = new Date();
      arbitraryEnd.setDate(arbitraryEnd.getDate() + 7);
      let todayDate = `${today.getMonth()+1}/${today.getDate()}/${today.getFullYear()}`;
      let todayTime = `${today.getHours() > 12 ? (today.getHours() - 12 < 10 ? `0${today.getHours() - 12}` : today.getHours() - 12) : today.getHours() === 0 ? '12' : today.getHours()}:${today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes()}:${today.getSeconds() > 9 ? today.getSeconds() : `0${today.getSeconds()}`}`
  
      try {
        const token = await getJwtToken();
        const res = await axios.post(
          'https://api.amplifyloyalty.com/app/stores/giveaways',
          {
            name: `New Giveaway - ${todayDate} ${todayTime}`,
          },
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        );
        if (res.data.name === 'BadRequestError') {
          handleSignOut();
        } else {
          setTimeout(() => {
            navigate(`/app/giveaways/${res.data._id}`);
          }, 2500);
        }
      } catch (err) {
        console.log(err)
        button.disabled = false;
        // responseHandler(err);
      }
    }
  }

  const duplicateGiveaway = async giveaway => {
    const button = document.querySelector('.giveaways-header__create-new');
    button.disabled = true;
    try {
      const token = await getJwtToken();
      const res = await axios.post(
        'https://api.amplifyloyalty.com/app/stores/giveaways/duplicate',
        {
          _id: giveaway._id,
          name: `${giveaway.name} - Copy`
        },
        {
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      if (res.data.name === 'BadRequestError') {
        handleSignOut();
      } else if (res.data._id) {
        console.log(res);
        setTimeout(() => {
          navigate(`/app/giveaways/${res.data._id}`);
        }, 1000);
      }
    } catch (err) {
      console.log(err);
      button.disabled = false;
      // responseHandler(err);
    }
  }
  
  const deleteGiveaway = async (doc) => {
    if (window.confirm('Are you sure you want to delete this Promotion? It cannot be undone.')) {
      try {
        const token = await getJwtToken();
        await axios.delete(
          'https://api.amplifyloyalty.com/app/stores/giveaways',
          {
            headers: { Authorization: `Bearer ${token}` },
            data: {
              _id: doc._id
            }
          }
        );
        setGiveaways(giveaways.filter(giv => giv._id !== doc._id));
      } catch (err) {
        console.log(err);
      }
    }
  }

  return (
    <div className="main">
      {tutorial === 1 && 
        <InitiateTutorial 
          text="In this guide, you will learn how to create new Giveaways to reward customers 
          with points or coupons based on interactions with your store."
          header="Creating Giveaways" 
          setTutorial={setTutorial}
        />
      }
      <CustomTable 
        data={giveaways} 
        setData={setGiveaways} 
        metrics={{
          recipients: {
            name: "Recipients"
          },
          orders: {
            name: "Orders"
          },
          sales: {
            name: "Sales",
            format: "money"
          }
        }}
        description="Create and schedule giveaways to incentivize your customers."
        objectName="Giveaway"
        endpoint="giveaways"
        pageInfo={pageInfo}
        setPageInfo={setPageInfo}
        createObject={createGiveaway}
        deleteObject={deleteGiveaway}
        editObject={navigate}
        duplicateObject={duplicateGiveaway}
        tutorial={tutorial}
        setTutorial={setTutorial}
        getJwtToken={getJwtToken}
      />
    </div>
  )
}